import { format } from 'date-fns'

import {
  DATE_API_DATA_FORMAT_SHORT,
  DATE_FULL_FORMAT_FROM_TIME,
} from '../../../../constants/date'
import {
  PROFILE_ROUTE_NAMES,
  ROUTE_PATH_LIST_RENTAL_PORTAL,
} from '../../../../constants/route'
import { createNowDateInUkTimezone } from '../../../../utils/date'
import { VIEWINGS_FILTER_PARAM } from '../../../RentalPortalViewing'
import { formatDate } from '../../../Table'
import { getRentalPortalSubsectionLink } from '../../RentalPortal.utils'
import { LISTINGS_FILTER_TOGGLE_VALUE } from '../../RentalPortalListings'
import { OVERVIEW_PAYLOAD_FIELD } from '../RentalPortalOverview.constants'

export function getOverviewViewingProfileLink(row) {
  return PROFILE_ROUTE_NAMES.rentalPortalViewingProfile({ id: row.viewing_id })
}

export function getOverviewViewingsShowAllLink({ overview, timezone }) {
  const params = new URLSearchParams({
    [VIEWINGS_FILTER_PARAM.booked]: LISTINGS_FILTER_TOGGLE_VALUE,
    [VIEWINGS_FILTER_PARAM.responsibleUser]:
      overview[OVERVIEW_PAYLOAD_FIELD.scopeUserId],
    [VIEWINGS_FILTER_PARAM.startGte]: format(
      createNowDateInUkTimezone(timezone),
      DATE_API_DATA_FORMAT_SHORT
    ),
  })

  return `${getRentalPortalSubsectionLink(ROUTE_PATH_LIST_RENTAL_PORTAL.viewings)}?${params}`
}

export function getOverviewViewingTimeLabel({ locale, scheduledAt, timezone }) {
  return formatDate({
    date: scheduledAt,
    dateFormat: DATE_FULL_FORMAT_FROM_TIME,
    locale,
    timezone,
    useTodayFormat: false,
  })
}
